import * as React from 'react'
import PropTypes from 'prop-types'
import { graphql, Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import useCDNImage, { getImageMeta } from '../../hooks/useCDNImage'
import { gridSizes } from '../../common/gatsbyImageData'
import ImageGalleryPopup from '../popups/ImageGallery'

export const ImageSection = ({ section, className = '' }) => {
  const { image, link, position, parent, parentPadding, lightbox } = section
  const [showImage, setShowImage] = React.useState(false)
  const showImageCallback = React.useCallback(() => setShowImage(0)) 
  const finalImage = useCDNImage(image, { productType: 'Mens Watch' }, gridSizes, '50vw')
  const props = {}
  let Wrapping = 'div'
  if (link) {
    Wrapping = Link
    props.to = link
  } else if (lightbox) {
    props.onClick = showImageCallback
    Wrapping = 'button'
  }
  // const padding =
  return (
    <section
      className={
        className +
        (position === 'top' && parent
          ? `${parentPadding ? '' : ' max-w-[800px] mx-auto '} xl:sticky top-0 self-start `
          : ' ')
      }
    >
      {image && finalImage && (
        <Wrapping {...props} className="w-full h-full text-center block">
          <GatsbyImage
            image={finalImage?.gatsbyImageData}
            alt={image.alternativeText || image.caption || section.caption || 'image'}
            className={'w-full h-full max-w-[500px] max-h-[500px]'}
            imgStyle={{ objectFit: 'contain' }}
          />
          {section.caption && (
            <figcaption className="text-sm text-center my-2">{section.caption}</figcaption>

          )}
        </Wrapping>
      )}
      {lightbox && showImage !== false && (
        <ImageGalleryPopup
          showImage={showImage}
          setShowImage={setShowImage}
          images={[getImageMeta(finalImage)]}
          product={{
            productType: 'Mens Watch',
            title: image.alternativeText || image.caption || 'image',
          }}
        />
      )}
    </section>
  )
}

ImageSection.propTypes = {
  section: PropTypes.shape({
    strapi_component: PropTypes.string,
    link: PropTypes.string,
    image: PropTypes.object,
    caption: PropTypes.string,
    position: PropTypes.string,
    parent: PropTypes.object,
    parentPadding: PropTypes.bool,
    lightbox: PropTypes.bool,
  }),
  className: PropTypes.string,
}

export const query = graphql`
  fragment ImageSection on STRAPI__COMPONENT_SECTION_IMAGE_SECTION {
    id
    strapi_component
    link
    position
    lightbox
    caption
    image {
      alternativeText
      caption
      gatsbyImageDataMock
    }
  }
`

export default ImageSection
